import { forwardRef, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface Props {
  children?: ReactNode;
  type?: "button" | "submit" | "reset" | undefined;
  color?: "primary" | "secondary" | "success" | "info" | "warning" | "error" | "neutral";
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  fullWidth?: boolean;
  onClick?: () => void;
  size?: "sm" | "md"; // 'sm' for small, 'md' for medium (default)
}

const FilledButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { children, type = "button", color = "", className = "", fullWidth = true, size = "md", onClick = () => {}, disabled = false, loading = false, ...rest } = props;
  return (
    <button
      //
      {...rest}
      ref={ref}
      disabled={disabled || loading}
      type={type}
      onClick={onClick}
      className={twMerge(
        "button relative filled",
        "transition-colors duration-200",
        size === "sm" ? "size-sm" : "",
        fullWidth ? "w-full" : "!px-16",
        color,
        className,
      )}
    >
      {/* {loading && <span className="absolute left-4 h-6 w-6 border-t-transparent border-solid animate-spin rounded-full" />} */}
      {children}
    </button>
  );
});

export default FilledButton;
